// extracted by mini-css-extract-plugin
module.exports = {"McsJasracBase":"McsJasrac_McsJasracBase__2Sqap","McsJasracLogo":"McsJasrac_McsJasracLogo__2zUkq","McsJasracRead":"McsJasrac_McsJasracRead__3y8_H"};